import { Calculator, BookOpen } from 'lucide-react';

/**
 * Pill matière compacte (maths / Français).
 * Convention couleur cohérente avec EtablissementView : Calculator bleu pour maths,
 * BookOpen ambre pour Français.
 *
 * Props :
 *   - matiere : 'maths' | 'Français'
 *   - size    : 'sm' | 'md' (défaut 'md')
 */
function MatiereBadge({ matiere, size = 'md' }) {
    const isMaths = matiere === 'maths';
    const Icon = isMaths ? Calculator : BookOpen;
    const label = isMaths ? 'Maths' : 'Français';
    const colorClass = isMaths
        ? 'bg-blue-50 text-blue-700 border-blue-200'
        : 'bg-amber-50 text-amber-700 border-amber-200';
    const sizeClass = size === 'sm'
        ? 'text-[10px] px-1.5 py-0.5 gap-0.5'
        : 'text-[11px] px-2 py-0.5 gap-1';
    const iconSize = size === 'sm' ? 'w-2.5 h-2.5' : 'w-3 h-3';

    return (
        <span className={`inline-flex items-center rounded-md border font-semibold ${colorClass} ${sizeClass}`}>
            <Icon className={iconSize} />
            {label}
        </span>
    );
}

export default MatiereBadge;
